// FastAPI/pydantic `detail` may be a string, an array of error objects, or an object.
// Returns `fallback` (null by default) when the response carries no detail.
export const formatApiError = (err, fallback = null) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(d => (typeof d === 'string' ? d : d?.msg || JSON.stringify(d))).join('; ');
  }
  if (typeof detail === 'object') return detail.message || detail.msg || JSON.stringify(detail);
  return String(detail);
};
